import { create } from '@thoughtspot/logger';
import Joi from 'joi';
import { getFlagsFromEventData } from './utils';
const logger = create('ts-to-chart > event-callbacks > get-blink-flags');
const schema = Joi.object({
    flags: Joi.array()
        .items(Joi.string()
        .max(60)
        .trim())
        .required()
        .allow()
        .empty(),
});
export const validateFlagEventsPayload = (eventData) => {
    try {
        Joi.assert(eventData.payload, schema);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
const getSessionFlagsProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateFlagEventsPayload(eventData);
        },
        executeEvent: async (eventData) => {
            const res = getFlagsFromEventData(eventData.payload.flags);
            return Promise.resolve(res);
        },
    };
};
export { getSessionFlagsProcessor };
//# sourceMappingURL=index.js.map